import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bi bi-volume-mute"
}
const _hoisted_2 = {
  key: 1,
  class: "bi bi-volume-up"
}

import { useModule } from 'src/modules/modules';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'audio-toggle-button',
  setup(__props) {

    const { audio } = useModule();
    const handleClick = () => audio.setMuted(!audio.muted)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", _mergeProps(_ctx.$attrs, {
    class: "au-audio-toggle-btn",
    onClick: handleClick
  }), [
    (_unref(audio).muted)
      ? (_openBlock(), _createElementBlock("i", _hoisted_1))
      : (_openBlock(), _createElementBlock("i", _hoisted_2))
  ], 16))
}
}

})